@if(loading$ | async) {
<app-loading class="h-100 w-100 loading-container" [text]="'Loading'"></app-loading>

} @else {
<div *ngIf="items.length" class="containe-fluid recommendations h-100 mt-4">
    <div class="shadow mb-5 bg-white rounded h-100 w-100 overflow-auto px-2">
        <div class="top-header p-3">
            <span class="mx-2"> Code Snippets without Test Case Coverage </span>
        </div>

        <div class="content p-4">
            <app-accordion [accordionData]="items"></app-accordion>
        </div>
    </div>
</div>

<div [hidden]="items.length" class="h-100 v-center">
    <app-no-data></app-no-data>
</div>
}